var util = require('app_custom_mufe/components/util');

module.exports = function () {
    $("#show-coupon-form").on("click", function() {
        $(".cart-promo-code-form").toggleClass( "cart-promo-code-form-show" );
    });

    $('body').on('product:afterAddToCart', function (e, response) {
        if (response.bambuserOTOCartUpdate) {
            var basketProductLineItems = {};
            basketProductLineItems = window.localStorage.getItem('basketProductLineItems') ? JSON.parse(window.localStorage.getItem('basketProductLineItems')) : {};
            Object.defineProperty(basketProductLineItems || {}, response.bambuserOTOCartUpdate.sku, {
                enumerable: true,
                value: response.bambuserOTOCartUpdate.uuid
            });
            window.localStorage.setItem('basketProductLineItems', JSON.stringify(basketProductLineItems));
        }
        var gtmData = [];
        var currencyCode = response.currencyCode != null ? response.currencyCode : "";
        var gtmPush = response.gtmPush != null ? response.gtmPush : null;
        if(response.error == false){
            $('.js-minicart .popover').spinner().start();
            $('html, body').addClass('disable_scrolling_minicart');
            const url = $('.js-minicart-desktop').data('action-url');

            $.get(url, function (datas) {
                $('.js-minicart .popover').empty();
                $('.js-minicart .popover').append(datas);
                $('.js-minicart .popover').slideDown('fast');

                quantitySelector();

                if (util.isMobile() || $(window).width() < 992) {
                    $('.js-minicart-mobile').focusout();
                } else {
                    $('.js-minicart-desktop').focusout();
                }
                $('#mini-cart-close-expanded').trigger('focus');
                $('.js-minicart .popover .mini-cart-close').focus();

                $.spinner().stop();
            });
            $.spinner().stop();
            $('.mini-cart-overlay').show();
            $('.add-to-cart-messages').hide();
        }else{
            $('.add-to-cart-messages').show();
        }

        if (gtmPush != null) {
            gtmData.push(gtmPush);
        }

        var addMethod = "product page";

        if ($('#pdp-sticky-wrapper').hasClass('fixed')) {
            addMethod = "sticky";
            $("html, body").scrollTop(0);
        }

        if ($("#quickbuy").length) {
            addMethod = "quick buy";
        }
        if ($('.page').attr('data-action') === 'Product-Show'){
            if ($(".shadefinderWrapper").length) {
                addMethod = "shade finder";
            }
            if (!$(".shadefinderWrapper").length && $(".vto-dialog").length) {
                addMethod = "virtual try on";
            }
        }

        dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': currencyCode,
                'add': {
                    'products': gtmData
                }
            },
            'add_method': addMethod
        });
    });

    function quantitySelector() {
        $('.min-cart-content .quantity-button').on('click', function () {
            var newVal, oldValue, maxValue;
            var pid = ($(this).attr("data-pid"));
            var traductionText = $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').data('text');
            $.spinner().start();

            if (!pid){
                oldValue = $(".min-cart-content #quantity option:selected").text();
                maxValue = parseInt($('.min-cart-content #quantity option:last').val());

                if (this.id == "quantity-plus") {
                    newVal = parseFloat(oldValue) + 1;
                    $(".min-cart-content #quantity option[value='"+newVal+"']").prop('selected', true);
                    $(".min-cart-content #quantity option[value='"+newVal+"']").text(newVal);
                    $('.min-cart-content #quantity-minus').prop('disabled', false);
                    if (oldValue >= maxValue - 1) {
                        $('.min-cart-content #quantity-plus').prop('disabled', true);
                    }
                } else {
                    if (oldValue > 0) {
                        newVal = parseFloat(oldValue) - 1;
                        $(".min-cart-content #quantity option[value='"+newVal+"']").prop('selected', true);
                        $(".min-cart-content #quantity option[value='"+newVal+"']").text(newVal);
                        $('.min-cart-content #quantity-plus').prop('disabled', false);
                        if (oldValue <= 2) {
                            $('.min-cart-content #quantity-minus').prop('disabled', true);
                        }
                    } else {
                        newVal = 0;
                    }
                }
                $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').text(traductionText + ' ' + newVal);
            } else {
                pid = ($(this).attr("data-pid"));
                oldValue = parseInt($('.min-cart-content .quantity[data-pid='+pid+'] option:selected').text());
                maxValue = parseInt($('.min-cart-content .quantity[data-pid='+pid+'] option:last').val());

                if (this.id === 'quantity-plus') {
                    newVal = parseFloat(oldValue) + 1;
                    $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").prop('selected', true);
                    $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").val(newVal).change();
                    $('.min-cart-content #quantity-minus[data-pid='+pid+']').prop('disabled', false);
                    if (oldValue >= maxValue) {
                        $('.min-cart-content #quantity-plus[data-pid='+pid+']').prop('disabled', true);
                        $.spinner().stop();
                    }
                } else {
                    if (oldValue > 0) {
                        newVal = parseFloat(oldValue) - 1;
                        $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").prop('selected', true);
                        $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").val(newVal).change();
                        $('.min-cart-content #quantity-plus[data-pid='+pid+']').prop('disabled', false);
                        if (oldValue <= 2) {
                            $('.min-cart-content #quantity-minus[data-pid='+pid+']').prop('disabled', true);
                            $.spinner().stop();
                        }
                    } else {
                        newVal = 0;
                    }
                }
                $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').text(traductionText + ' ' + newVal);
            }
        });
    }

    $(document).ready(function () {
        $('.change-my-shade').click(function(){
            $("html, body").scrollTop(0);
        })
        $('.pdp-content .tabPanel').each(function(){
            if (($(window).width() < 992)) {
                var currentTabPDP = $(this).attr('aria-labelledby');
                $(this).parent().prev('.navigationTabs').find('#' + currentTabPDP).removeAttr('role aria-labelledby')
                $(this).removeAttr('role aria-labelledby');
            }else{
                $('.pdp-content .tabPanel:first-child').addClass('active');
                $('.pdp-content .tabPanel:first-child').find('.pdp-description-block').addClass('active');
                $('.pdp-content .tabPanel:first-child').find('.pdp-description-content').addClass('show');
                $('.pdp-content .tabPanel:first-child').find('.pdp-description-title').attr('aria-expanded','true');
            }
        });
        (($(window).width() < 992)) ? $('#descriptionPanel').removeClass('active') : '' ;

        $('#descriptionTab, #ingredientTab, #howtoTab, #inspirationTab').on('keydown', function (e) {
            var currentTab = $(this).attr('aria-controls');
            switch (e.which) {
                case 39:
                    if ($(this).hasClass('active')) {
                        if ($(this).next('.nav-item').length > 0) {
                            $('.tab-content').find('.tabPanel ').removeClass('active');
                            $('.tab-content').find('#' + currentTab).next().addClass('active');
                            $(this).removeClass('active').attr({'aria-selected' : 'false', 'tabindex' : -1});
                            $(this).next('.nav-item').addClass('active').attr({'aria-selected' : 'true', 'tabindex' : 0}).focus();
                        }
                    }
                    break;
                case 37:
                    if ($(this).hasClass('active')) {
                        if ($(this).prev('.nav-item').length > 0) {
                            $('.tab-content').find('.tabPanel ').removeClass('active');
                            $('.tab-content').find('#' + currentTab).prev().addClass('active');
                            $(this).removeClass('active').attr({ 'aria-selected': 'false', 'tabindex' : -1});
                            $(this).prev('.nav-item').addClass('active').attr({ 'aria-selected': 'true', 'tabindex' : 0}).focus();
                        }
                    }
                    break;
            }
        })
            .on('click', function () {
                if (!$(this).hasClass('active')) {
                    var currentTab = $(this).attr('aria-controls');
                    $('.nav-item').removeClass('active').attr({'aria-selected' : 'false', 'tabindex' : -1});
                    $(this).addClass('active').attr({'aria-selected' : 'true', 'tabindex' : 0}).focus();
                    $('.tab-content').find('.tabPanel ').removeClass('active');
                    $('.tab-content').find('#' + currentTab).addClass('active');
                }
            });
    });

    $(window).on('load', function() {
        $(".ratings").show();
        $(".reviews").show();
    });
}
